var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTraining = function SvgTraining(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#training_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#training_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBF3FF",
    d: "M43.532.468h-38.4a4.8 4.8 0 0 0-4.8 4.8v38.4a4.8 4.8 0 0 0 4.8 4.8h38.4a4.8 4.8 0 0 0 4.8-4.8v-38.4a4.8 4.8 0 0 0-4.8-4.8"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#training_svg__c)",
    d: "M30.728 53.016c-6.996.3-13.992.324-20.988.084-2.232-.084-4.128-2.004-4.176-4.236a514 514 0 0 1-.048-23.16c.072-3.252 2.844-6.072 6.096-6.168a267 267 0 0 1 19.116.144c1.032.048 1.908.936 1.944 1.968.288 9.804.288 19.596 0 29.4-.036 1.032-.9 1.92-1.944 1.968"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF9F3",
    d: "M27.127 28.907H16.735a1.26 1.26 0 0 0-1.26 1.26v4.896c0 .696.564 1.26 1.26 1.26h10.392a1.26 1.26 0 0 0 1.26-1.26v-4.896a1.26 1.26 0 0 0-1.26-1.26"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D19F62",
    d: "M8.372 19.5h3.852v33.432H8.576a3.337 3.337 0 0 1-3.336-3.337V22.645A3.147 3.147 0 0 1 8.384 19.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#BC854A",
    d: "M12.393 19.764h-.336v33.168h.336z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#training_svg__d)",
    d: "M38.875 31.558c-5.705.244-11.42.244-17.124 0-1.922-.092-3.692-1.77-3.824-3.701a83 83 0 0 1 0-10.993c.132-1.922 1.902-3.61 3.824-3.702 5.704-.244 11.42-.244 17.124 0 1.922.092 3.691 1.77 3.823 3.702.245 3.66.245 7.332 0 10.993-.132 1.921-1.901 3.61-3.823 3.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2F7FF",
    d: "M34.361 21.643c-2.054-1.24-4.108-2.603-6.03-3.722-.54-.315-1.271.153-1.312.803a66 66 0 0 0 0 7.25c.04.652.773 1.12 1.312.804 1.912-1.118 3.976-2.47 6.03-3.722a.821.821 0 0 0 0-1.423z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "training_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(14.9682 0 0 15.756 19.206 36.348)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCAD70"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "training_svg__d",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "translate(30.313 22.365)scale(17.1446)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DC2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D7FEB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "training_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.332.5h48v48h-48z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "training_svg__b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    x: 0.332,
    y: 0.468,
    fill: "#fff",
    rx: 8
  })))));
};
export default SvgTraining;